<template>
  <div class="child2">
    <el-form
            ref="form"
            :model="form"
            label-width="10px"
            size="small"
    >
      <el-form-item
      >
        拼团订单明细
        <el-divider></el-divider>
      </el-form-item>
      <el-form-item
      >
  <el-table
          :data="tableData"
          v-loading="loading"
          size="small"
          stripe
          highlight-current-row
          style="width: 100%;"
          @selection-change="handleSelectionChange"
          @sort-change="handleSortChange"
  >

    <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50px">
    </el-table-column>
    <el-table-column
            label="商铺名称"
    >
      <template slot-scope="scope">
        {{scope.row.agent_name}}
      </template>
    </el-table-column>

    <el-table-column
            label="商家LOGO"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.agent_logo!=null && scope.row.agent_logo!=''">
          <img :src= "getImgUrl(scope.row)" style="width: 100px;height: 100px; "/>
        </div>

      </template>
    </el-table-column>
    <el-table-column
            label="价格(元)"
    >
      <template slot-scope="scope">
        {{scope.row.amount}}
      </template>
    </el-table-column>
    <el-table-column
            label="订单号"
    >
      <template slot-scope="scope">
        {{scope.row.order_id}}
      </template>
    </el-table-column>
    <el-table-column
            label="拼团开始时间"
    >
      <template slot-scope="scope">
        {{scope.row.insert_times}}
      </template>
    </el-table-column>
    <el-table-column
            label="拼团结束时间"
    >
      <template slot-scope="scope">
        {{scope.row.end_times}}
      </template>
    </el-table-column>
    <el-table-column
            label="拼团完成时间"
    >
      <template slot-scope="scope">
        {{scope.row.complete_times}}
      </template>
    </el-table-column>
    <el-table-column
            label="状态"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.is_pt=='0'">
          <div v-if="scope.row.stat=='0'">
            拼团中
          </div>
          <div v-else-if="scope.row.stat=='1'">
            拼团成功
          </div>
          <div v-else-if="scope.row.stat=='2'">
            拼团失败
          </div>
        </div>
        <div v-else-if="scope.row.is_pt=='1'">
          <div v-if="scope.row.stat=='0'">
            待支付
          </div>
          <div v-else-if="scope.row.stat=='1'">
            购买成功
          </div>
          <div v-else-if="scope.row.stat=='2'">
            购买失败
          </div>
        </div>

      </template>
    </el-table-column>
    <el-table-column
            label="商家地址"
    >
      <template slot-scope="scope">
        {{scope.row.agent_adress}}
      </template>
    </el-table-column>
    <el-table-column
            label="商品图片"
    >

      <template slot-scope="scope">
        <div v-if="scope.row.good_url!=null && scope.row.good_url!=''">



          <span v-for="(item,index) in scope.row.good_url.split(',')">
              <span v-if="index==0">
                 <span v-if="item.indexOf('mp4') !=-1">
              <video
                      v-bind:src="getImgUrl2(scope.row)"
                      class="avatar video-avatar"
                      controls="controls"  style="width: 200px;height: 100px; "></video>
              </span>
              <span v-else>
                 <img :src= "getImgUrl2(scope.row)" style="width: 200px;height: 100px; "/>
              </span>
              </span>
          </span>


        </div>

      </template>
    </el-table-column>
    <el-table-column
            label="商品名称"
    >
      <template slot-scope="scope">
        {{scope.row.good_name}}
      </template>
    </el-table-column>
    <el-table-column
            label="发起人"
    >
      <template slot-scope="scope">
        {{scope.row.sponsor_wx}}
      </template>
    </el-table-column>
    <el-table-column
            label="发起人微信头像"
    >
      <template slot-scope="scope">


        <div v-if="scope.row.sponsor_img_url!=null && scope.row.sponsor_img_url!=''">
          <img :src= "getImgUrl3(scope.row)" style="width: 100px;height: 100px; "/>
        </div>

      </template>
    </el-table-column>
    <el-table-column
            label="拼团人数"
    >
      <template slot-scope="scope">
        {{scope.row.group_num}}
      </template>
    </el-table-column>
    <el-table-column
            label="拼团成功数量"
    >
      <template slot-scope="scope">
        {{scope.row.group_success_num}}
      </template>
    </el-table-column>
    <el-table-column
            label="抱团未成功补贴(%)"
    >
      <template slot-scope="scope">
        {{scope.row.group_subsidy}}
      </template>
    </el-table-column>

    <el-table-column
            label="操作"
            width="200"
    >
      <template slot-scope="scope">

        <el-button type="primary" plain  size="mini"    @click="openViewForm2(scope.row)">详情</el-button>


      </template>
    </el-table-column>


  </el-table>
  <div style="text-align: center;margin-top: 30px;">
    <el-pagination
            :current-page="page.current"
            :page-size="page.size"
            :total="page.total"
            :page-sizes="[1,10,50,100, 200, 300, 400]"
            layout="total, sizes, prev, pager, next, jumper"
            style="margin: -10px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>

      </el-form-item>

    </el-form>

  </div>

</template>

<script>
import * as agentService from "@/api/sys/agent";

import util from '@/libs/util.js'
export default {
  name: "PayTurnover",
  data() {
    return {
        loading: false,
        start_time:'',
        end_time:'',

        form: {},
        tableData: [],
        multipleSelection: [],
        page: {
            current: 1,
            size: 10,
            total: 0
        },
        sort: {
            prop: "",
            order: ""
        }
    };
  },
    mounted() {

      //  console.log("========");
        //this.getTableData();
    },
  methods: {
      openViewForm2(agent){
          this.$emit('refreshTurnover',agent.id+'');
      },

      getTableData() {
          let query = {
              pageIndex: this.page.current,
              pageSize: this.page.size,
              sortBy: this.sort.prop,
              agentid: util.cookies.get('agentid'),
              dl_type: util.cookies.get('dl_type'),
              xt_id: util.cookies.get('xt_id'),
          start_time:this.start_time,
              end_time:this.end_time,

              descending: this.sort.order === "descending"
          };
          agentService.getOrderDdPagedlist(query).then(data => {
              this.tableData = data.rows;
              this.page.total = data.totalCount;
          });
      },
    getImgUrl(row){
      return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+row.agent_logo;
    },
    getImgUrl2(row){
      var good_url=row.good_url;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[0];
      }

      return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+good_url;
    },
    getImgUrl3(row){
      var good_url=row.sponsor_img_url;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[1];
      }

      return good_url;
    },
      handleSearchFormSubmit() {
          this.getTableData();
      },
      handleSearchFormReset() {
          this.$refs.searchForm.resetFields();
      },
      handleSelectionChange(val) {
          this.multipleSelection = val;
      },
      handleSortChange(val) {
          this.sort.prop = val.prop;
          this.sort.order = val.order;
          this.getTableData();
      },
      handleSizeChange(val) {
          this.page.size = val;
          this.getTableData();
      },
      handleCurrentChange(val) {
          this.page.current = val;
          this.getTableData();
      }
  }
};
</script>


